import { h, Host } from "@stencil/core";
export class CheckboxListItem {
    constructor() {
        this.value = undefined;
        this.label = undefined;
        this.name = "";
        this.checked = false;
        this.disabled = false;
        this.inputId = undefined;
        this.isActive = this.checked;
    }
    element;
    radioButtonElement;
    /** redispatches the uxRadioButtonChange event, otherwise not interceptable in SPAs */
    radioListItemEvent;
    onRadioListItemChange(e) {
        if (e.target === this.radioButtonElement) {
            this.radioListItemEvent.emit(e.detail);
            this.isActive = true;
        }
        else {
            const targetParentDropdown = e.target.closest("ux-dropdown");
            const elementParentDropdown = this.element.closest("ux-dropdown");
            if (targetParentDropdown === elementParentDropdown) {
                this.isActive = false;
            }
        }
    }
    render() {
        const baseClass = "ux-radio-list-item";
        return (h(Host, { key: '6cb9e6f80cd95b760333f8976dcf1a0880869b6c', class: {
                [baseClass]: true,
                [`${baseClass}--active`]: this.isActive
            }, role: "listitem" }, h("ux-radio-button", { key: '19715fcff48255ef5a0617727d01480420e44978', value: this.value, label: this.label, name: this.name, checked: this.checked, disabled: this.disabled,
            // @ts-expect-error Check for typing
            ref: (el) => (this.radioButtonElement = el),
            // @ts-expect-error Check for typing
            inputId: this.inputId || null }, h("slot", { key: 'dcbedf4100598d75aa6db35bc820ae25ebf3d833' }))));
    }
    static get is() { return "ux-radio-list-item"; }
    static get originalStyleUrls() {
        return {
            "$": ["radio-list-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["radio-list-item.css"]
        };
    }
    static get properties() {
        return {
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "this value is used on the checkbox inside this item"
                },
                "attribute": "value",
                "reflect": false
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This is the label that is displayed for this item inside the dropdown"
                },
                "attribute": "label",
                "reflect": false
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "name which is used for checkbox groups or as identifier in forms"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "checked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the radio button is checked"
                },
                "attribute": "checked",
                "reflect": false,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the radio button is disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "inputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Input id attribute to be passed down to the radio button"
                },
                "attribute": "input-id",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "isActive": {}
        };
    }
    static get events() {
        return [{
                "method": "radioListItemEvent",
                "name": "uxRadioListItemChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "redispatches the uxRadioButtonChange event, otherwise not interceptable in SPAs"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
    static get listeners() {
        return [{
                "name": "uxRadioButtonChange",
                "method": "onRadioListItemChange",
                "target": "window",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=radio-list-item.js.map
